/**
 * Cliente das rotas da própria conta.
 *
 * Nenhuma delas recebe identificador de usuário. Quem está falando vem do
 * token, verificado no servidor — mandar o `user_id` no corpo seria oferecer
 * um campo para alguém tentar preencher com o de outra pessoa.
 */

import { api } from '@/lib/apiClient';

/** Os papéis que a pessoa escolhe no onboarding. */
export type SelfAssignableRole = 'student' | 'professional';

/**
 * Todos os papéis que `/me` pode devolver.
 *
 * `admin` fica fora de `SelfAssignableRole` porque a API o recusa no
 * onboarding — a policy `user_roles_self_insert` só admite os outros dois.
 * Manter os dois tipos separados faz o compilador impedir o formulário de
 * oferecer uma opção que o servidor rejeitaria.
 */
export type Role = SelfAssignableRole | 'admin';
export type UnitSystem = 'metric' | 'imperial';
export type ConsentDocument = 'terms' | 'privacy' | 'health_disclaimer';

export interface Me {
  user_id: string;
  display_name: string | null;
  locale: string;
  unit_system: UnitSystem;
  timezone: string;
  country_code: string | null;
  onboarding_status: 'pending' | 'in_progress' | 'completed';
  roles: Role[];
  missing_consents: ConsentDocument[];
}

export interface OnboardingPayload {
  display_name: string;
  locale: string;
  unit_system: UnitSystem;
  timezone: string;
  jurisdiction: string;
  roles: SelfAssignableRole[];
  consents: Array<{ document: ConsentDocument; accepted: boolean }>;
}

export const getMe = () => api.get<Me>('/me');

export const submitOnboarding = (payload: OnboardingPayload) =>
  api.post<Me>('/me/onboarding', payload);

export const deleteAccount = () => api.delete<void>('/me');
